<template lang="html">
  <div class="activity">
    <ShareHeader :openTarget="jumpTarget" />

    <div class="activity_mod">
      <div class="banner">
        <img v-bind:src="activity.cover" alt="" class="bannerImg">
        <div class="WillNum">
          <img src="../../assets/image/activity/people.png" alt="" class="peopleIcon">
          {{ activity.show_view_num }}
        </div>
      </div>

      <div class="activity_content">
        <div class="activity_title_module">
          <p class="activity_title">{{activity.title}}</p>
          <div class="price">
            <div class="activity_price">
              <div class="new_price">
                <p class="current_price">{{activity.price}}</p>
                <p class="current_price_txt">巢币</p>
              </div>
              <div class="old_price">
                <p class="origin_price">{{activity.origin_price}} 巢币</p>
                <p class="origin_price_txt"></p>
              </div>
            </div>
            <div class="activity_state"> {{ setTime }} </div>
          </div>
        </div>

        <div class="activity_time_site">
          <div class="activity_time_module">
            <div class="time_title">
              <img src="../../assets/image/time.png">
              <p>活动时间</p>
            </div>
            <div class="activity_time">
              <div id="endTimg"> {{activity.activity_time}} </div>
            </div>
          </div>
          <!-- <div class="activity_site_module" @click="actSite()">
            <div class="site_title">
              <img src="../../assets/image/site.png">
              <p>活动地点</p>
            </div>
            <div class="activity_site">
              <div> {{activity.address}} </div>
              <p> > </p>
            </div>
          </div> -->
        </div>

        <!-- 添加微信群 -->
        <div class="activity_teacher" v-if="activity.type_id != 1">
          <div class="activity_peopleNumber">
            <p>大咖交流群</p>
            <p> (1000+人已加入) </p>
          </div>
          <div class="activity_people">
            <div>
              <img src="../../assets/image/teacher_qun.png" alt="">
            </div>
          </div>
          <div class="add_vx" @click="addVx()" v-show="addVxshow">
            <img src="../../assets/image/vx_group.png" alt="">
            <p>点击加入群聊</p>
          </div>
        </div>
        <div class="activity_teacher" v-if="activity.type_id == 1">
          <div class="activity_peopleNumber">
            <p>大咖交流群</p>
            <p> (1000+人已加入) </p>
          </div>
          <div class="activity_people">
            <div>
              <img src="../../assets/image/teacher_qun.png" alt="">
            </div>
          </div>
          <div class="add_vx" @click="addVx()" v-show="addVxshow">
            <img src="../../assets/image/vx_live.png" alt="">
            <p>点击获取直播入口</p>
          </div>
        </div>

        <ul class="tab_tilte">
          <li class="tab_mod" v-show="detailsShow" @click="cur=0" :class="{active:cur==0}">
            活动详情
          </li>
          <li class="tab_mod" @click="cur=1" :class="{active:cur==1, elseActive: isActive}">
            分享嘉宾
          </li>
          <li class="tab_mod" @click="cur=2" :class="{active:cur==2, elseActive: isActive}">
            活动相关
          </li>
        </ul>
        <div class="tab_content">
          <div v-show="cur==0">
            <div class="details_model" v-html="datas">
              {{datas}}
            </div>
            <div class="" style="height:40px;"></div>
          </div>
          <div v-show="cur==1">
            <div class="guese_content" v-for="(m, index) in activity.guest" :key="index">
              <div class="guese_teacher">
                <div class="guese_head">
                  <img :src="m.avatar" alt="">
                </div>
                <div class="teacher_introduce">
                  <p class="teacher_name">{{m.name}}</p>
                  <p class="teacher_title">{{m.title}}</p>
                  <p class="teacher_skills">{{m.skills}}</p>
                </div>
              </div>
            </div>
            <div class="" style="height: 50px;"></div>
          </div>
          <div v-show="cur==2">
            <div class="else_content" v-for="(m, index) in activity.more_list" :key="index">
              <div class="else_teacher">
                <div class="else_head">
                  <img :src="m.cover" alt="">
                  <div class="state" v-if="m.free_in_time > 0">
                    限时免费
                  </div>
                </div>
                <div class="else_act">
                  <p class="else_act_title">{{m.title}}</p>
                  <p class="else_act_time">报名时间: {{m.reg_time}}</p>
                  <p class="else_act_people"><span class="people_num">{{m.join_num}}</span>人参加</p>
                </div>
              </div>
              <WxOpenTag :extinfo="elseActivity(m.id)" />
            </div>
            <div class="" style="height:50px;"></div>
          </div>
        </div>

        <!-- 置顶 -->
        <div class="activity_top" @click="returnTop()">
          <img src="../../assets/image/top.png" alt="">
        </div>
        <!-- APP下载 -->
        <div class="isFixed" v-show="appBtn">
          <img src="../../assets/image/appDownload.png" alt="">
          <WxOpenTag :extinfo="jumpTarget" />
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="footer_share" @click="btnClicked()">
        <img src="../../assets/image/share.png" alt="" class="share_img">
        分享
      </div>
      <div class="footer_applyBtn" :style="{background: activity.color}" @click="routerTo(activity.status)">
        {{actState}}
        <WxOpenTag :extinfo="jumpTarget" v-show="callAppShow" />
      </div>
      <router-link tag="div" :to="{ path:'/more', query:{ id: this.$route.query.id } }" class="footer_all">
        <img src="../../assets/image/else.png" alt="" class="share_img">
        更多
      </router-link>
    </div>

    <shareShortcut :shareVisible="shareVisible" @shareCancel="shareCancel" :activityId="activityId" :detailUrl="activity.detail_url" />

    <GroupChat :groupVisible="groupVisible" @groupCancel="groupCancel" :headPortrait="activity.group.avatar" :actName="activity.group.name" :yard="activity.group.qrcode" />

    <div class="live_mode" v-show="live_show">
      <div class="vx_conent">
        <img src="../../assets/image/VXlogo.png" alt="" class="vxLogo">
        <div class="vx_footer">
          <div class="vx_ma">
            <img :src="activity.qrcode" alt="">
          </div>
          <div class="vx_txt">
            长按图片识别二维码
          </div>
        </div>
      </div>
      <div class="" @click="live_of()">
        <img src="../../assets/image/VX_off.png" alt="" class="on_off">
      </div>
    </div>
  </div>
</template>

<script>
  import ShareHeader from '@/components/HeadModule'
  import ShareShortcut from '@/components/ShareShortcut'
  import GroupChat from '@/components/GroupChat'

  import Cookies from 'js-cookie';
  import WxShare from '@/utils/wxshare';
  import {bbc2html} from '@/utils/bbcode';
  import {pagehost} from '@/utils/http.js';
  import WxOpenTag from '@/components/WxOpenTag';
  import {pagebase} from '@/utils/http.js';

  export default {
    data() {
      return {
        activity: {
          group: {}
        },
        setTime: '',
        addVxshow: true,
        cur: 0,
        datas: '',
        appBtn: false,
        jumpTarget: '',
        detailsShow: false,
        isActive: false,
        currentTime: Math.trunc(new Date().getTime() / 1000),
        actState: "立即报名",
        shareVisible: false,
        activityId: this.$route.query.id,
        groupVisible: false,
        live_show: false,
        callAppShow: false,
        channelType: this.$route.query.channel || '',
      }
    },

    components: {
      ShareHeader,
      WxOpenTag,
      ShareShortcut,
      GroupChat,
    },

    mounted() {
      this.info();
      /*页面统计*/
      this.$http('/api/showStat', {
        params: {
          url: location.href,
          type: 0,
          uid: Cookies.get('uid') || '',
          token: Cookies.get('token') || ''
        }
      })
    },

    methods: {
      info() {
        // this.callApp();
        this.getActivity()
      },

      getActivity() {
        this.$http({
          url: '/activity/detail',
          method: 'get',
          params: {
            activity_id: this.$route.query.id,
            uid: Cookies.get('uid') || '',
            token: Cookies.get('token') || '',
            track: this.$route.query.track,
            reg_channel: 'pc',
          },
        }).then((res) => {
          if (res.code >= 0) {
            document.getElementsByTagName("title")[0].innerHTML = res.data.title;
            this.activity = res.data;

            // 微信分享
            new WxShare().share({
              title: this.activity.title,
              desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
              link: window.location.href,
              imgUrl: this.activity.cover,
            })

            this.activityType();
            this.addVxShow();
            // 活动倒计时
            setInterval(() => {
              this.setTime = this.Times();
            }, 1000);

            this.$http({
              url: "/Post/details",
              method: 'get',
              params: {
                start: '0',
                limit: '1',
                topicid: res.data.tid,
              },
            }).then((res) => {
              if (res.code >= 0) {
                this.cur = 0,
                  this.detailsShow = true;
                this.datas = bbc2html(res.data[0].message);
              } else {
                this.cur = 1,
                  this.detailsShow = false;
                this.isActive = true;
              }
            })
          }
          window.addEventListener('scroll', this.handleScroll)
        })
      },

      callApp() {
        let thisUrl = 'webView/detail?url=' + pagehost + '/html/activity/activity.html?activityId=' + this.$route.query.id + '&hideNativeNav=1';
        this.jumpTarget = thisUrl;
      },

      activityType() {
        if (this.activity.status == 1) {
          if (this.activity.join_status) {
            this.actState = '查看报名结果';
          } else {
            this.actState = '立即报名';
          }
          this.jumpTarget = 'webView/detail?url=' + pagehost + '/html/activity/activity.html?activityId=' + this.$route.query.id + '&hideNativeNav=1';
        }
        if (this.activity.status == 2) {
          this.actState = '暂未开始';
          this.activity['color'] = 'linear-gradient(to right, #FBC2CA, #FFA4A4)';
          this.jumpTarget = 'webView/detail?url=' + pagehost + '/html/activity/activity.html?activityId=' + this.$route.query.id + '&hideNativeNav=1';
        }
        if (this.activity.status == 3) {
          if (this.activity.type_id == 1) {
            if (this.currentTime < this.activity.live_end_time) {
              if (this.activity.join_status) {
                this.callAppShow = true;
                this.actState = '进入直播';
                this.jumpTarget = 'live/detail?url=' + this.activity.live_url;
              } else {
                this.actState = '进入直播';
                this.jumpTarget = 'live/detail?url=' + this.activity.live_url;
              }
            }
            if (this.currentTime > this.activity.live_end_time) {
              this.callAppShow = true;
              this.actState = '查看回放';
              this.jumpTarget = 'class/detail?id=' + this.activity.course_id;
            }
          } else {
            this.actState = '活动结束';
            this.activity['color'] = "#D8D8D8";
          }
        }
      },

      routerTo(status) {
        this.$http({
          url: '/activity/checkUserIsLogin',
          method: 'get',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
            reg_channel: 'pc',
          }
        }).then(res => {
          if (res.code >= 0) {
            // 报名中
            if (status == 1) {
              // 填资料报名
              if (this.activity.reg_type == 0) {
                // 已报名
                if (this.activity.join_status > 0) {
                  this.$router.push({
                    path: '/succeed',
                    query: {
                      id: this.$route.query.id,
                      type_id: this.activity.type_id,
                      channel: this.channelType,
                    }
                  });
                } else {
                  this.$router.push({
                    path: '/apply',
                    query: {
                      id: this.$route.query.id,
                      type_id: this.activity.type_id,
                      channel: this.channelType,
                    }
                  });
                }
              }

              // 直接账号报名
              if (this.activity.reg_type == 1) {
                this.$http({
                  url: '/activity/activityRegister',
                  method: 'post',
                  params: {
                    activity_id: this.$route.query.id,
                    uid: Cookies.get('uid'),
                    token: Cookies.get('token'),
                    reg_channel: 'pc',
                  }
                }).then(res => {
                  if (res.code >= 0 || res.code == "-21") {
                    this.$router.push({
                      path: '/succeed',
                      query: {
                        id: this.$route.query.id,
                        type_id: this.activity.type_id,
                        channel: this.channelType,
                      }
                    });
                  }
                })
              }
            }

            if (status == 3) {
              if (this.currentTime < this.activity.live_end_time) {
                if (!this.activity.join_status) {
                  this.$router.push({
                    path: '/apply',
                    query: {
                      id: this.$route.query.id,
                      type_id: this.activity.type_id,
                      join_status: this.activity.join_status,
                      channel: this.channelType,
                    }
                  });
                }
              }
            }
          } else {
            location.replace(`${pagebase}/#/login?type=1&redirect=${encodeURIComponent(location.href)}`)
          }
        })
      },

      // 活动倒计时
      Times() {
        let endTime = '';
        let stateTimes = new Date().getTime();
        let eTime = this.strToDate(this.activity.end_time).getTime() - stateTimes;
        let h = parseInt(eTime / 1000 / 60 / 60);
        let m = parseInt(eTime / 1000 / 60 % 60);
        let s = parseInt(eTime / 1000 % 60);
        if (h < 10) {
          h = '0' + h;
        }
        if (m < 10) {
          m = '0' + m;
        }
        if (s < 10) {
          s = '0' + s;
        }
        if (parseInt(eTime / 1000) <= 0) {
          let act = '报名截止';
          return act;
        } else {
          if (h <= 24) {
            endTime = h + '时' + m + '分' + s + '秒后截止';
            return endTime;
          } else {
            let day = parseInt(eTime / 1000 / 60 / 60 / 24);
            let h = parseInt(eTime / 1000 / 60 / 60 % 24);
            if (h < 10) {
              h = '0' + h;
            }
            endTime = day + '天' + h + '时' + m + '分' + s + '秒后截止';
            return endTime;
          }
        }
      },
      // ios 时间转换
      strToDate(dateObj) {
        dateObj = dateObj.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').replace(/(-)/g, '/')
        if (dateObj.indexOf(".") > 0) dateObj = dateObj.slice(0, dateObj.indexOf("."))
        return new Date(dateObj)
      },

      // 地图
      // actSite() {
      //   if (this.activity.longitude != '' && this.activity.latitude != '') {
      //     this.$router.push({
      //       path: '/amap',
      //       query: {
      //         id: this.$route.query.id,
      //       }
      //     });
      //   } else {
      //     return;
      //   }
      // },

      addVxShow() {
        if (this.activity.group == '') {
          this.addVxshow = false
        } else {
          this.addVxshow = true
        }
      },

      elseActivity(id) {
        let thisUrl = pagehost + '/html/activity/activity.html?activityId=' + id + '&hideNativeNav=1';
        let path = 'webView/detail?url=' + thisUrl;
        return path;
      },

      // 置顶
      returnTop() {
        window.scrollTo(0, 0);
      },

      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 500) {
          this.appBtn = true;
        } else {
          this.appBtn = false;
        }
      },

      // 加微信
      addVx() {
        this.groupVisible = true;
      },
      // 分享
      btnClicked() {
        this.shareVisible = true;
      },
      shareCancel() {
        this.shareVisible = false;
      },
      groupCancel() {
        this.groupVisible = false
      },
      liveShow() {
        this.live_show = true;
      },
      live_of() {
        this.live_show = false;
      },
    },
  }
</script>

<style lang="css" scoped>
  .activity {
    width: 100%;
    height: 100%;
  }

  .activity_mod {
    height: 100%;
  }

  .banner {
    width: 100%;
    height: 26rem;
    object-fit: cover;
    position: relative;
  }

  .bannerImg {
    width: 100%;
    height: 26rem;
    object-fit: cover;
  }

  .WillNum {
    text-align: center;
    position: absolute;
    top: 19rem;
    right: 1.5rem;
    color: #ffffff;
    font-size: 2rem;
    padding: 0 1rem;
    height: 2.5rem;
    line-height: 2.6rem;
    border-radius: 1.3rem;
    background-color: rgba(249, 249, 249, 0.4);
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .peopleIcon {
    width: 1.9rem;
    height: 1.9rem;
  }

  .activity_content {
    background-color: #F7F8F8;
    position: relative;
    top: -2.8rem;
    border-radius: 20px 20px 0 0;
  }

  .activity_title_module {
    background-color: #ffffff;
    padding: 18px;
    border-radius: 20px 20px 0 0;
  }

  .activity_title {
    font-size: 18px;
    font-weight: 400;
    color: #1D2023;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .price {
    display: flex;
    margin-top: 10px;
    align-items: center;
    justify-content: space-between;
  }

  .activity_price {
    display: flex;
    align-items: flex-end;
  }

  .new_price {
    display: flex;
    align-items: flex-end;
  }

  .current_price {
    font-size: 24px;
    color: #E50120;
  }

  .current_price_txt {
    font-size: 12px;
    color: #E50120;
    position: relative;
    top: -3px;
    left: 2px;
  }

  .old_price {
    margin-left: 8px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 1px;
    text-decoration: line-through;
  }

  .origin_price {
    font-size: 12px;
    color: #9CA3A9;
  }

  .origin_price_txt {
    font-size: 12px;
    color: #9CA3A9;
    position: relative;
    top: -2px;
  }

  .activity_state {
    font-size: 12px;
    color: #F5A623;
  }

  .activity_time_site {
    margin-top: 10px;
    padding: 18px;
    background-color: #ffffff;
  }

  /* 时间 */
  .activity_time_module {
    display: flex;
    justify-content: space-between;
  }

  .time_title {
    width: 100px;
    display: flex;
    align-items: center;
  }

  .time_title img {
    width: 21px;
  }

  .time_title p {
    font-size: 16px;
    font-weight: 400;
    padding-left: 5px;
  }

  .activity_time {
    display: flex;
    align-items: center;
  }

  .activity_time div {
    color: #606972;
    font-size: 12px;
  }

  /* 地点 */
  .activity_site_module {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
  }

  .site_title {
    width: 100px;
    display: flex;
    align-items: center;
  }

  .site_title img {
    width: 21px;
  }

  .site_title p {
    font-size: 16px;
    font-weight: 400;
    padding-left: 5px;
  }

  .activity_site {
    display: flex;
    align-items: center;
  }

  .activity_site div {
    width: 200px;
    overflow: hidden;
    word-break: keep-all;
    white-space: nowrap;
    color: #606972;
    font-size: 12px;
    margin-right: 10px;
    text-align: right;
  }

  .activity_site p {
    font-size: 12px;
    color: #606972;
  }

  .activity_teacher {
    margin-top: 10px;
    padding: 0 18px;
    background-color: #ffffff;
  }

  .activity_peopleNumber {
    font-weight: 600;
    padding-top: 15px;
    display: flex;
  }

  .activity_people {
    width: 100%;
    margin-top: 16px;
  }

  .activity_people img {
    width: 100%;
    padding-bottom: 16px;
  }

  #activity_omit {
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: linear-gradient(#FBD249, #F5A623);
    font-size: 22px;
    color: #ffffff;
  }

  .add_vx {
    margin-top: 16px;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .add_vx img {
    width: 44px;
  }

  .add_vx p {
    color: #F5A623;
    font-size: 16px;
    margin-left: 10px;
  }

  /* 置顶 */
  .activity_top {
    position: fixed;
    top: 55%;
    right: 20px;
    z-index: 20;
  }

  .activity_top img {
    width: 40px;
  }

  .activity_content_child {
    margin-top: 10px;
    padding: 0 18px;
    background-color: #ffffff;
  }

  /* tab */
  .activity_details {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }

  .activity_details div {
    padding-top: 8px;
    width: 33.333333%;
    text-align: center;
    font-size: 16px;
  }

  .activity_details div p {
    height: 40px;
    line-height: 40px;
  }

  .act {
    color: red;
  }

  .act p {
    display: inline-block;
    border-bottom: 2.5px solid red;
  }

  /* footer */
  .footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    text-align: center;
    z-index: 10;
  }

  .footer_share {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25%;
    height: 50px;
    line-height: 50px;
    background-color: #FDF7F7;
    color: #E50120;
    font-size: 14px;
  }

  .footer_share img {
    width: 18px;
    margin-right: 5px;
  }

  .share_img {
    width: 22px;
  }

  .footer_applyBtn {
    position: relative;
    width: 50%;
    height: 50px;
    line-height: 50px;
    background-color: red;
    color: #ffffff;
    font-size: 18px;
  }

  .footer_all {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25%;
    height: 50px;
    line-height: 50px;
    background-color: #F5A623;
    color: #ffffff;
    font-size: 14px;
  }

  .footer_all img {
    width: 18px;
    margin-right: 5px;
  }

  .appdown {
    position: relative;
  }

  .isFixed {
    position: fixed;
    right: 0;
    bottom: 30%;
    z-index: 10;
  }

  .isFixed img {
    width: 72px;
  }


  /* tab */
  .tab_tilte {
    width: 100%;
    height: 4.4rem;
    display: flex;
    text-align: center;
    border-bottom: .05rem solid #DDDDDD;
    background-color: #FFF;
  }

  .tab_mod {
    width: 33.33%;
    height: 4.4rem;
    line-height: 4.4rem;
    font-size: 1.6rem;
  }

  .active {
    color: #F00021;
    position: relative;
  }

  .active:after {
    content: '';
    position: absolute;
    left: 50%;
    right: 0;
    text-align: center;
    bottom: 0;
    height: 2px;
    width: 30px;
    margin-left: -15px;
    background-color: #F00021;
  }

  .tab_content {
    background-color: #fff;
    box-sizing: border-box;
    padding: .5rem 1.5rem;
  }

  .elseActive {
    width: 50%;
  }

  @media (min-width: 750px) {
    .footer {
      width: 750px;
    }

    .activity_top {
      left: 50%;
      margin-top: -20px;
      margin-left: 270px;
    }

    .isFixed {
      left: 50%;
      margin-left: 300px;
    }

    .peopleIcon {
      height: 1.9rem;
    }

    .else_act_title {
      max-width: none;
    }
  }

  /* 分享嘉宾css */
  .guese {
    width: 100%;
  }

  .guese_content {
    box-sizing: border-box;
    width: 100%;
    padding: 12px 0;
    line-height: 25px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.07);
  }

  .guese_teacher {
    height: 85px;
    display: flex;
  }

  .guese_head img {
    width: 85px;
    height: 85px;
    border-radius: 20px;
    object-fit: cover;
  }

  .teacher_introduce {
    width: 100%;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .teacher_name {
    font-size: 14px;
    font-weight: 400;
    color: #1F2126;
  }

  .teacher_title {
    max-width: 235px;
    line-height: 15px;
    font-size: 11px;
    color: #606972;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .teacher_skills {
    font-size: 12px;
    color: #E50120;
    max-width: 240px;
    overflow: hidden;
    word-break: keep-all;
    white-space: nowrap;
  }

  /* 活动相关css */
  .else {
    width: 100%;
  }

  .else_content {
    position: relative;
    width: 100%;
    padding: 12px 0;
  }

  .else_teacher {
    height: 85px;
    display: flex;
  }

  .else_head {
    position: relative;
  }

  .else_head img {
    width: 123px;
    height: 85px;
    border-radius: 5px;
    object-fit: cover;
  }

  .state {
    height: 16px;
    line-height: 16px;
    font-size: 10px;
    color: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #F5A623;
    border-radius: 5px 0 16px 0;
    padding: 1px 10px;
  }

  .else_act {
    width: 100%;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .else_act_title {
    max-width: 235px;
    line-height: 18px;
    font-size: 14px;
    color: #1D2023;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .else_act_time {
    font-size: 11px;
    font-weight: 400;
    color: #606972;
  }

  .else_act_people {
    font-size: 12px;
    color: #9CA3A9;
    max-width: 240px;
    overflow: hidden;
    word-break: keep-all;
    white-space: nowrap;
  }

  .people_num {
    font-size: 14px;
    color: #87B43B;
  }

  @media (min-width: 500px) {
    .else_act_title {
      max-width: none;
    }
  }

  /* 直播弹框 */
  .live_mode {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .vx_conent {
    width: 290px;
    height: 290px;
    background-color: #ffffff;
  }

  .vxLogo {
    width: 95px;
    position: absolute;
    left: 50%;
    margin-top: -48px;
    margin-left: -55px;
  }

  .vx_footer {
    height: 285px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .vx_ma {
    margin-top: 20px;
    width: 140px;
    height: 140px;
    background-color: #D8D8D8;
  }

  .vx_ma img {
    width: 100%;
    height: 100%;
  }

  .vx_txt {
    width: 165px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #E50120;
    margin-top: 30px;
    border: 1px solid #E50120;
    border-radius: 11px;
  }

  .on_off {
    margin-top: 25px;
    width: 50px;
  }


  .decorationLine {
    color: red;
    position: relative;
  }

  .decorationLine:after {
    content: '';
    position: absolute;
    left: 50%;
    right: 0;
    text-align: center;
    bottom: 0;
    height: 2.5px;
    width: 60px;
    margin-left: -30px;
    background-color: #F00021;
  }
</style>
